export class GlobalResponse {
    http_code: string;
    message: string;
    result: any;
}
